<template>
    <v-container fluid>
    <field-form ref="form" @save="save" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" @cancel="cancelWizard()" v-if="item">
    <h2 class="text-h4">{{ $t('mailing.title') }}</h2>
    
    <v-row>
        <v-col cols="12" md="6">
    <v-card id="pfid1618854159" class="fill-height">
    <v-card-title>{{$t('mailing.dns.title')}}</v-card-title>
    <v-card-text>
    <v-text-field id="pfid1618854165" :label="$t('mailing.dns.domain')" :placeholder="item.name.toLowerCase()" prepend-icon="$dnsDomain" v-model="fields.dnsName" :rules="[rules.required, rules.dnsName]" class="pr-3"></v-text-field>
    <v-text-field id="pfid1618854169" disabled :label="$t('mailing.dns.bounce')" placeholder="info" prepend-icon="$dnsMailFrom" v-model="fields.mailFrom" :suffix="`.${fields.dnsName || item.name}`" :rules="[rules.required, rules.bounce]" class="pr-3"></v-text-field>
    </v-card-text>
    <v-card-actions>
        <v-btn text type="submit" @click="$refs.form.nwSave = true" color="primary" :loading="saving || loading"><v-icon left>$ok</v-icon>{{$t('mailing.dns.generate')}}</v-btn>
    </v-card-actions>
    </v-card>
        </v-col>
        <v-col cols="12" md="6">
    <v-card  class="fill-height">
    <v-card-title>{{$t('mailing.message.title')}}</v-card-title>
    <v-card-text>
    <v-text-field id="pfid1618854175" :label="$t('mailing.message.sender.email')" placeholder="news" prepend-icon="$mailing" v-model="fields.from" :suffix="`@${fields.dnsName || item.name}`"  :rules="[rules.inbox]" class="pr-3"></v-text-field>
    <v-text-field id="pfid1618854178" :label="$t('mailing.message.sender.name')" :placeholder="item.name" prepend-icon="$rename" v-model="fields.friendlyFrom" class="pr-3"></v-text-field>
    <v-text-field id="pfid1618854181" :label="$t('mailing.message.replyTo')" :placeholder="$t('mailing.message.placeholder.replyTo')" prepend-icon="$mailing" v-model="fields.replyTo" :suffix="`@${fields.dnsName || item.name}`" :rules="[rules.inbox]" class="pr-3"></v-text-field>
    <!-- This is dreamroi, no setup
    <v-text-field label="Tracking domain" placeholder="dreamroi" prepend-icon="$dnsMailFrom" :suffix="fields.dnsDomain || item.name"></v-text-field>
    -->
    </v-card-text>
    </v-card>
        </v-col>
    </v-row>
    </field-form>
    <v-skeleton-loader type="heading,paragraph" v-else />
    <v-row class="mt-3" no-gutters>
    <h3 class="text-h5">{{$t('mailing.dns.records.title')}}</h3>
    <v-spacer />
    <action-button @click="copyRecords" icon="$copy" :tooltip="$t('common.code.copyAll')" color="primary" fab small dark />
    <action-button button-class="mx-1" @click="mailRecords" icon="$mailing" :tooltip="$t('common.code.mailAll')" color="primary" fab small dark />
    <action-button icon="$refresh" tooltip="Refresh" color="primary" fab small dark @click="getDNSRecords" :loading="loading"/>
    </v-row>
    
    <v-alert type="info" class="mt-3" colored-border border="left" v-if="item && !item.dnsRecords && !loading">
        <div v-html="$t('mailing.dns.fillIn')" />
    </v-alert>
    <template v-if="item && item.dnsRecords" >
    <v-alert class="my-3" type="warning" colored-border border="left"><div v-html="$t('mailing.dns.delay')" /></v-alert>
    <!--
    <div v-if="item && item.dnsRecords">
        {{ JSON.stringify(item.dnsRecords) }}
    </div>
    -->
    <v-row no-gutters align="center" class="mb-2">
    <v-icon color="error">$required</v-icon><h4 class="text-h6 ml-2">{{$t('form.required')}}</h4>
    </v-row>
    <v-simple-table
    id="pfid1618854316" >
        <thead>
        <tr>
          <th class="text-left">
            {{ $t('mailing.dns.headers.status') }}
          </th>
          <th class="text-left">
            {{ $t('mailing.dns.headers.recordType') }}
          </th>
          <th class="text-left">
            {{ $t('mailing.dns.headers.key') }}
          </th>
          <th class="text-left">
            {{ $t('mailing.dns.headers.value') }}
          </th>
        </tr>
      </thead>
      <tbody>
          <tr class="pfcl1618854270" v-for="(token,i) in item.dnsRecords.dkim.DkimTokens" :key="`token${i}`">
          <td>
              <v-icon v-if="hasDkim" color="success">$ok</v-icon>
                <v-icon v-else color="warning">$pending</v-icon>
          </td>
          <td><code>CNAME</code></td>
          <td><code>{{token}}._domainkey.{{item.dnsName}}</code>
          <action-button :tooltip="$t('common.code.copy')" icon="$copy" x-small @click="copy(`${token}._domainkey.${item.dnsName}`)"/></td>
          <td><code>{{token}}.dkim.amazonses.com</code>
          <action-button :tooltip="$t('common.code.copy')" icon="$copy" x-small @click="copy(`${token}.dkim.amazonses.com`)"/></td>
          </tr>
          <tr
          id="pfid1618854300" 
          >
            <td>
              <v-icon v-if="hasTrackingDomain" color="success">$ok</v-icon>
              <v-icon v-else color="warning">$pending</v-icon>
            </td>
            <td><code>CNAME</code></td>
            <td><code>dreamroi-tr.{{item.dnsName}}</code>
            <action-button :tooltip="$t('common.code.copy')" icon="$copy" x-small @click="copy(`dreamroi-tr.${item.dnsName}`)"/></td>
            <td><code>tracker.dreamroi.com</code>
            <action-button :tooltip="$t('common.code.copy')" icon="$copy" x-small @click="copy(`tracker.dreamroi.com`)"/></td>
          </tr>
      </tbody>
    </v-simple-table>
    <v-row no-gutters align="center" class="my-2">
    <v-icon color="success">$ok</v-icon><h4 class="text-h6 ml-2">{{$t('form.optional')}}</h4>
    </v-row>
    <v-simple-table
    id="pfid1618854316" >
        <thead>
        <tr>
          <th class="text-left">
            {{ $t('mailing.dns.headers.status') }}
          </th>
          <th class="text-left">
            {{ $t('mailing.dns.headers.recordType') }}
          </th>
          <th class="text-left">
            {{ $t('mailing.dns.headers.key') }}
          </th>
          <th class="text-left">
            {{ $t('mailing.dns.headers.value') }}
          </th>
        </tr>
      </thead>
      <tbody>
          <tr
          id="pfid1618854288" 
          >
            <td>
              <v-icon v-if="hasMailFrom" color="success">$ok</v-icon>
              <v-icon v-else color="warning">$pending</v-icon>
            </td>
            <td><code>MX</code></td>
            <td><code>{{ item.dnsRecords.mailFromDomain.MailFromDomain }}</code>
            <action-button :tooltip="$t('common.code.copy')" icon="$copy" x-small @click="copy(item.dnsRecords.mailFromDomain.MailFromDomain)"/></td>
            <td><code>10 feedback-smtp.eu-central-1.amazonses.com</code>
            <action-button :tooltip="$t('common.code.copy')" icon="$copy" x-small @click="copy(`10 feedback-smtp.eu-central-1.amazonses.com`)"/></td>
          </tr>
          <tr
          id="pfid1618854294" 
          >
            <td>
              <v-icon v-if="hasMailFrom" color="success">$ok</v-icon>
              <v-icon v-else color="warning">$pending</v-icon>
            </td>
            <td><code>TXT</code></td>
            <td><code>{{ item.dnsRecords.mailFromDomain.MailFromDomain }}</code>
            <action-button :tooltip="$t('common.code.copy')" icon="$copy" x-small @click="copy(item.dnsRecords.mailFromDomain.MailFromDomain)"/></td>
            <td><code>v=spf1 include:amazonses.com ~all</code>
            <action-button :tooltip="$t('common.code.copy')" icon="$copy" x-small @click="copy(`v=spf1 include:amazonses.com ~all`)"/></td>
          </tr>
      </tbody>
    </v-simple-table>
    </template>
    <v-skeleton-loader class="mt-3" type="table" v-if="loading" />
    </v-container>
</template>
<script>

import EntityForm from "@/mixins/entity-form"
import Capabilities from "@/mixins/capabilities"
import Wizards from "@/mixins/wizards"
import DnsRecords from "@/mixins/dns-records"
//import {mapGetters} from "vuex"

export default {
    name: 'MailingSettings',
    mixins: [Capabilities, EntityForm, Wizards, DnsRecords],
    data() {
        return {
            endpoint: 'domains',
            fields: {
                dnsName: null,
                mailFrom: null,
                from: null,
                friendlyFrom: null,
                replyTo: null
            },
            loading: false
        }
    },
    watch: {
        item(val, oldVal) {
            if((!oldVal && val) || (val && oldVal && val.id != oldVal.id)) {
                this.getDNSRecords();
            } 
        }
    },
    computed: {
        allRecords() {
            if(!this.item?.dnsRecords) {
                return '';
            }
            return `
------------------ ${this.$t('form.required')} ------------------\n\n

${this.item.dnsRecords.dkim.DkimTokens.map(token => [`${this.$t('mailing.dns.headers.recordType').toUpperCase()}:\tCNAME`, `${this.$t('mailing.dns.headers.key').toUpperCase()}:\t${token}._domainkey.${this.item.dnsName}`,`${this.$t('mailing.dns.headers.value').toUpperCase()}:\t${token}.dkim.amazonses.com`].join('\n')).join('\n\n')}

${this.$t('mailing.dns.headers.recordType').toUpperCase()}:\tCNAME
${this.$t('mailing.dns.headers.key').toUpperCase()}:\tdreamroi-tr.${this.item.dnsName}
${this.$t('mailing.dns.headers.value').toUpperCase()}:\ttracker.dreamroi.com

------------------ ${this.$t('form.optional')} ------------------\n\n

${this.$t('mailing.dns.headers.recordType').toUpperCase()}:\tMX
${this.$t('mailing.dns.headers.key').toUpperCase()}:\t${this.item.dnsRecords.mailFromDomain.MailFromDomain}
${this.$t('mailing.dns.headers.value').toUpperCase()}:\t10 feedback-smtp.eu-central-1.amazonses.com

${this.$t('mailing.dns.headers.recordType').toUpperCase()}:\tTXT
${this.$t('mailing.dns.headers.key').toUpperCase()}:\t${this.item.dnsRecords.mailFromDomain.MailFromDomain}
${this.$t('mailing.dns.headers.value').toUpperCase()}:\tv=spf1 include:amazonses.com ~all
`
        },

        //...mapGetters('ui', ['mediaUrl'])
    },
    methods: {
        afterFieldsLoad() {
            if(!this.fields.dnsName) {
                this.fields.dnsName = this.item.name.toLowerCase();
            }
            if(!this.fields.mailFrom) {
                this.fields.mailFrom = 'dreamroi-bounces';
            }
        },
        beforeSave(fields) {
            //console.dir(fields);
            // check capabilities and switch to ACTIVE if all conditions met
            // this is never used  - this must be binded to the getDNSrecords
            /*
            fields.capabilities = Object.assign({}, this.item.capabilities);
            
            if(fields.hasDkim && !fields.capabilities.dkim) {
                fields.capabilities.dkim = true;
            }
            if(fields.hasMailFrom && !fields.capabilities.spf) {
                fields.capabilities.spf = true;
            }
            if(fields.hasTrackingDomain && !fields.capabilities.linkDomain) {
                fields.capabilities.linkDomain = true;
            }

            if(this.item.active == 'INACTIVE' && this.canActivate(fields.capabilities)) {
                fields.active = 'ACTIVE';
            }
            */
            return fields;
        },
        afterSave() {
            this.getDNSRecords();
        },
        prepareFields(nowizard) {
            if(!nowizard && !this.item.dnsRecords) {
                this.$store.dispatch('ui/notify', {text: this.$t('mailing.errors.noRecords')});
                return false;
            } 
        },
        copy(value) {
           this.$copyText(value).then((e) => {
            this.$store.dispatch('ui/notify', { text: this.$t('common.valueCopied')});
            console.debug(e);
            }, (e) => {
                this.$store.dispatch('ui/notify', { text: this.$t('common.valueCopyError'), error: true });
                console.debug(e)
            })
        },
        copyRecords() {
            this.copy(this.allRecords);
        },
        mailRecords() {
            let mailto = `mailto:?subject=${encodeURIComponent('DreamROI: ' + this.$t('mailing.title'))}&body=${encodeURIComponent(this.allRecords)}`;
            window.open(mailto, '_blank');
        }
    },
    created() {
        if(this.item) {
            this.getDNSRecords();
        }
    }
}
</script>